
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1440","height":"900","viewBox":"0 0 1440 900","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1490-50H-50V950h1540V-50zM720 20C60 20 45.5 34.5 40 40S20 60 20 450s14.5 404.5 20 410 20 20 680 20 674.5-14.5 680-20 20-20 20-410-14.5-404.5-20-410-20-20-680-20z","fill":"#000"}}),_c('path',{attrs:{"d":"M1327.57 719.229L1339 691l.46 1.186-11.03 27.585-34.52 37.518-15.97 30.94-.61-.991 15.76-30.527 34.48-37.482z","fill":"#FFFFE9","fill-opacity":".1"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1327.57 718.229l10.97-27.415.46.186.26.684-10.83 27.087-34.52 37.518-16.41 31.211-.44-.729 16.03-31.06 34.48-37.482z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h1440v900H0z"}})])])])
          )
        }
      }
    